<template>
    <div>
        <b-card class="shadow mb-5 ml-md-5 mr-md-5 ml-0 mr-0" v-if="!stub">
            
            <div class="d-flex w-100 flex-column flex-lg-row align-items-baseline justify-content-center mb-4">

                <b-button variant="link"
                        class="flex-grow-0 d-flex align-items-center text-secondary flex-nowrap mb-3 mb-lg-0"
                        @click="$router.replace({name: 'animalsList'})">
                    <b-icon icon="chevron-left" class="mr-2"/>
                    <span>К списку</span>
                </b-button>

                <div class="d-flex flex-grow-1 mb-2">
                    <div class="d-flex flex-column align-items-start align-items-lg-center flex-grow-1">
                        <span class="d-flex align-items-center flex-wrap">
                            <span class="h3 m-0 mr-2 text-nowrap">
                                <span class="text-wrap">
                                    <span>{{ title }}</span>
                                    <span v-if="object.id"> №{{ object.regNumber }}</span>
                                </span>
                                <sup><small v-if="!object.id" class="text-secondary ml-2">Новое</small></sup>
                                <span class="ml-2" v-if="object.reviewed"><b-icon icon="check-circle-fill" variant="success" class="ml-1" v-b-tooltip="getReviewTooltip()"/></span>
                                <span class="ml-2" v-if="!object.reviewed && object.reviewDate"><b-icon icon="question-circle-fill" variant="warning" class="ml-1" v-b-tooltip="getStaleReviewTooltip()"/></span>
                            </span>
                            <span class="tag danger mb-1" v-if="object.lastSurveyObject && object.lastSurveyObject['attributes']['isAggressive']">Агрессивное</span>
                        </span>
                        <span v-if="object.shelterRegNumber" class="mt-2 h4 text-secondary">{{ object.shelterRegNumber }}</span>
                        <div v-if="object.isArchived" class="d-flex flex-grow-1 mb-3 mt-3">
                            <span class="text-secondary border rounded" style="padding: 5px 12px">В архиве c {{ object.archiveDate }}</span>
                        </div>
                    </div>
                </div>

                <div class="d-flex flex-grow-0 align-items-center mb-2" v-if="object.id && canDownloadPdf">
                    <download-button :url="downloadUrl" size-variant="md">
                        <template #title>
                            <span>Выгрузить в pdf</span>
                        </template>
                    </download-button>
                </div>
            </div>
            <b-tabs v-model="tabIndex">
                <b-tab title="Информация" ref="infoTab">
                    <div class="d-flex flex-column flex-lg-row p-3 mt-3">
                        <animal-primary-avatar
                                :animal="form"
                                :image="form.image"
                                @animal-avatar-updated="onAvatarUpdated"
                                @animal-avatar-uploaded="onAvatarUploaded"/>

                        <div class="flex-grow-1">

                            <b-form-row class="mb-3">
                                <b-col class="d-flex flex-wrap col-xs-12"  md="6" lg="4" v-if="isSuperuser">
                                    <form-field class="required mr-3 mb-3"
                                                 :label="getFieldLabel('regNumber')"
                                                 :editable="isSuperuser"
                                                 :value="object.regNumber"
                                                 :feedback="liveFeedback('regNumber')">
                                        <template #field>
                                            <b-form-input
                                                id="regNumber"
                                                class="w-100"
                                                type="text"
                                                v-model="$v.form.regNumber.$model"
                                                :state="validateState('regNumber')">
                                            </b-form-input>
                                        </template>
                                    </form-field>
                                </b-col>
                                <b-col v-else class="d-flex flex-wrap align-items-center"  md="6" lg="4">
                                    <span class="form-field-label text-secondary mr-2">Рег. №</span>
                                    <span>{{object.regNumber}}</span>
                                </b-col>
                            </b-form-row>

                            <b-form-row>
                                <b-col class="d-flex flex-wrap mb-3" md="6" lg="8" xl="5">
                                    <date-time-picker ref="reviewDate"
                                                      class="w-100"
                                                      title="Дата проверки"
                                                      name="reviewDate"
                                                      :editable="Boolean(objectId) && getAbility('reviewDate')"
                                                      :key="getReviewDateStr()"
                                                      :show-timepicker="false"
                                                      :date-required="true"
                                                      :time-required="true"
                                                      :required="false"
                                                      :state="validateState('reviewDate')"
                                                      :initial-date-string="getReviewDateStr()"
                                                      :clearable="true"
                                                      @date-changed="onReviewDateChanged" />
                                    <small v-if="object.reviewDate && object.reviewDate === $v.form.reviewDate.$model" class="text-secondary">в {{ object.reviewDate.split(' ')[1] }}</small>
                                </b-col>
                            </b-form-row>

                            <b-form-row>
                                <b-col class="d-flex flex-wrap">
                                    <form-field class="required mr-3 mb-3"
                                                 :label="getFieldLabel('shelterRegNumber')"
                                                 :editable="getAbility('shelterRegNumber')
                                                    && !object.reviewed
                                                    && (!object.keepingPlaceId || object.keepingPlaceId && object.keepingPlaceId === userOrganizationId)"
                                                 :value="object.shelterRegNumber"
                                                 :feedback="liveFeedback('shelterRegNumber')">
                                        <template #field>
                                            <b-form-input
                                                id="shelterRegNumber"
                                                class="w-100"
                                                type="text"
                                                v-model="$v.form.shelterRegNumber.$model"
                                                :state="validateState('shelterRegNumber')">
                                            </b-form-input>
                                        </template>
                                    </form-field>
                                </b-col>
                            </b-form-row>

                            <b-form-row>
                                <b-col class="d-flex flex-wrap">
                                    <form-field  class="required mr-5 mb-3 p-0"
                                                 :label="getFieldLabel('breed')"
                                                 :editable="getAbility('breed') && (!objectId || !object.keepingPlaceId || (userLastValidContract && object.keepingPlaceId && object.keepingPlaceId === userLastValidContract['contractor_id']))"
                                                 :value="object.breedObject ? object.breedObject['full_name']: null"
                                                 :feedback="liveFeedback('breed')">
                                        <template #field>
                                                <single-select name="breed"
                                                               class="flex-grow-1 mr-2"
                                                               v-model="form['breedObject']"
                                                               :url="getBreedsUrl"
                                                               label-key="full_name"
                                                               :has-search="false"
                                                               :label="getFieldLabel('breed')"
                                                               :state="getValidationClass('breed')"
                                                               v-on:select-changed="onModelObjectSingleSelectChanged"
                                                               v-on:select-cleared="onModelObjectSingleSelectCleared" />
                                        </template>
                                    </form-field>

                                    <form-field v-if="objectId"
                                                class="mb-3"
                                                label="Пол"
                                                :editable="false"
                                                :value="object.genderName">
                                    </form-field>

                                </b-col>
                            </b-form-row>

                            <b-form-row  class="mb-2">
                                <b-col class="d-flex flex-wrap">
                                    <form-field class="col-sm-3 col-md-2 col-lg-1 mr-0 mr-sm-3 p-0 mb-3"
                                                 :label="getFieldLabel('labelId')"
                                                 :editable="!object.id && getAbility('labelId')"
                                                 :value="object.labelId"
                                                 :feedback="liveFeedback('labelId')">
                                        <template #field>
                                            <b-form-input
                                                id="labelId"
                                                class="w-100"
                                                type="text"
                                                v-model="$v.form.labelId.$model"
                                                :state="validateState('labelId')">
                                            </b-form-input>
                                        </template>
                                    </form-field>

                                    <form-field class="col-sm-6 col-md-3 p-0"
                                                 :label="getFieldLabel('chipId')"
                                                 :editable="!object.id && getAbility('chipId')"
                                                 :value="object.chipId"
                                                 :feedback="liveFeedback('chipId')">
                                        <template #field>
                                            <b-form-input
                                                id="chipId"
                                                class="w-100"
                                                type="text"
                                                v-model="$v.form.chipId.$model"
                                                :state="validateState('chipId')">
                                            </b-form-input>
                                        </template>
                                    </form-field>
                                </b-col>
                            </b-form-row>

                            <object-form-buttons :has-changes="hasChanges"
                                 :object-exists="Boolean(object.id)"
                                 @object-create="onCreate"
                                 @object-update="updateObject"
                                 @object-cancel-changes="cancelChanges"/>

                            <b-form-row class="mb-5" v-if="object.id">
                                <b-col sm="12">
                                    <b-button v-if="!object.reviewed && !object.hasLastDistinctiveData && canCreateInitialInspectionEvents && (object.currentPack || (!object.currentPack && !object.lastCatchingRequestId))"
                                              variant="info" @click="addInitialInspection">
                                        <b-icon icon="plus" class="mr-2"/>
                                        <span>Добавить данные первичного осмотра</span>
                                    </b-button>
                                    <div v-else-if="object.hasLastDistinctiveData" class="d-flex flex-column">
                                        <b-link v-if="ability.can('read', 'ClinicalEvent')" :to="{ name: 'eventDetail', params: { id: object.lastInitialInspectionObject['id'] } }"
                                                class="h5 mb-3" >
                                            <b-icon icon="link45deg" class="mr-2"/>
                                            <span>Первичный осмотр</span>
                                        </b-link>
                                        <span v-else class="h5 mb-3">Первичный осмотр</span>

                                        <div class="d-flex flex-column">
                                            <div class="d-flex flex-wrap mb-3">
                                                <div class="d-flex flex-column mr-5 mb-3">
                                                    <small class="text-secondary">Возраст</small>
                                                    <span v-if="object.lastDistinctiveData['age']">{{ object.lastDistinctiveData['age'] }} лет</span>
                                                    <span v-else>&mdash;</span>
                                                </div>

                                                <div class="d-flex flex-column mr-5 mb-3">
                                                    <small class="text-secondary">Вес</small>
                                                    <span v-if="object.lastDistinctiveData['weight']">{{ object.lastDistinctiveData['weight'] }} кг</span>
                                                    <span v-else>&mdash;</span>
                                                </div>

                                                <div class="d-flex flex-column mr-5">
                                                    <small class="text-secondary">Высота в холке</small>
                                                    <span v-if="object.lastDistinctiveData['height']">{{ object.lastDistinctiveData['height'] }} см</span>
                                                    <span v-else>&mdash;</span>
                                                </div>
                                            </div>

                                            <div class="d-flex flex-wrap mb-3">
                                                <div class="d-flex flex-column mr-5 mb-3">
                                                    <small class="text-secondary">Окрас</small>
                                                    <span v-if="object.lastDistinctiveData['color']">{{ object.lastDistinctiveData['color'] }}</span>
                                                    <span v-else>&mdash;</span>
                                                </div>

                                                <div class="d-flex flex-column mr-5 mb-3">
                                                    <small class="text-secondary">Шерсть</small>
                                                    <span v-if="object.hairTypeText">{{ object.hairTypeText }}</span>
                                                    <span v-else>&mdash;</span>
                                                </div>

                                                <div class="d-flex flex-column mr-5 mb-3">
                                                    <small class="text-secondary">Уши</small>
                                                    <span v-if="object.earCropText">{{ object.earCropText }}</span>
                                                    <span v-else>&mdash;</span>
                                                </div>

                                                <div class="d-flex flex-column mr-5">
                                                    <small class="text-secondary">Хвост</small>
                                                    <span v-if="object.tailCropText">{{ object.tailCropText }}</span>
                                                    <span v-else>&mdash;</span>
                                                </div>
                                            </div>

                                            <div class="d-flex flex-wrap mb-3">
                                                <div class="d-flex flex-column mr-5">
                                                    <small class="text-secondary">Особые приметы</small>
                                                    <span v-if="object.lastDistinctiveData['distinctive']">{{ object.lastDistinctiveData['distinctive'] }}</span>
                                                    <span v-else>&mdash;</span>
                                                </div>
                                            </div>

                                            <div class="d-flex flex-wrap mb-3">
                                                <div class="d-flex flex-column mr-5">
                                                    <small class="text-secondary">Стерилизовано</small>
                                                    <span v-if="object.lastDistinctiveData.hasOwnProperty('earlySterilization')">
                                                        <span v-if="object.lastDistinctiveData['earlySterilization']">Да</span>
                                                        <span v-else>Нет</span>
                                                    </span>
                                                    <span v-else>&mdash;</span>
                                                </div>

                                                <div class="d-flex flex-column mr-5">
                                                    <small class="text-secondary">Дата стерилизации</small>
                                                    <span v-if="object.lastDistinctiveData.hasOwnProperty('earlySterilization')">
                                                        <span v-if="object.lastDistinctiveData['earlySterilization'] && object.lastDistinctiveData['earlySterilizationDate']">
                                                            {{ object.lastDistinctiveData['earlySterilizationDate'] }}
                                                        </span>
                                                        <span v-else>Нет</span>
                                                    </span>
                                                    <span v-else>&mdash;</span>
                                                </div>
                                            </div>

                                            <div class="d-flex flex-wrap mb-3">
                                                <div class="d-flex flex-column mr-5 mb-3">
                                                    <small class="text-secondary">Бирка</small>
                                                    <span v-if="object.lastDistinctiveData['labelId']">{{ object.lastDistinctiveData['labelId'] }}</span>
                                                    <span v-else>&mdash;</span>
                                                </div>

                                                <div class="d-flex flex-column mr-5 mb-3">
                                                    <small class="text-secondary">Чип</small>
                                                    <span v-if="object.lastDistinctiveData['chipId']">{{ object.lastDistinctiveData['chipId'] }}</span>
                                                    <span v-else>&mdash;</span>
                                                </div>
                                            </div>

                                            <div class="d-flex flex-wrap mb-3">
                                                <div class="d-flex flex-column mr-5">
                                                    <small class="text-secondary">Повторно отловлено</small>
                                                    <span v-if="object.lastDistinctiveData.hasOwnProperty('repeatedCatching')">
                                                        <span v-if="object.lastDistinctiveData['repeatedCatching']">Да</span>
                                                        <span v-else>Нет</span>
                                                    </span>
                                                    <span v-else>&mdash;</span>
                                                </div>
                                            </div>

                                            <div class="d-flex flex-wrap">
                                                <div class="d-flex flex-column mr-5">
                                                    <small class="text-secondary">Комментарий</small>
                                                    <span v-if="object.lastDistinctiveData['comment']">{{ object.lastDistinctiveData['comment'] }}</span>
                                                    <span v-else>&mdash;</span>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                    <div v-else>
                                        <span>Первичный осмотр не проводился</span>
                                    </div>
                                </b-col>
                            </b-form-row>

                            <b-form-row v-if="object.id">
                                <b-col sm="12">
                                    <b-button v-if="!object.reviewed
                                                    && !object.lastKeepingData
                                                    && canCreateKeepingEvents
                                                    && (object.currentPack || (!object.currentPack && !object.lastCatchingRequestId))
                                                    && !object.keepingPlaceId" variant="info" @click="addKeeping">
                                        <b-icon icon="plus" class="mr-2"/>
                                        <span>Добавить запись о содержании</span>
                                    </b-button>

                                    <div v-if="!object.isShelterInfoRestricted && (object.lastKeepingData || object.lastDisposalData)" class="d-flex flex-column">
                                            <b-link v-if="object.lastKeepingData && ability.can('read', 'KeepingEvent') && object.isKept"
                                                    :to="{ name: 'eventDetail', params: { id: object.lastKeepingData['id'] } }"
                                                    class="h5 mb-3" >
                                                <b-icon icon="link45deg" class="mr-2"/>
                                                <span>Содержание и выбытие</span>
                                            </b-link>
                                            <b-link v-else-if="object.lastDisposalData && ability.can('read', 'DisposalEvent')"
                                                    :to="{ name: 'eventDetail', params: { id: object.lastDisposalData['id'] } }"
                                                    class="h5 mb-3" >
                                                <b-icon icon="link45deg" class="mr-2"/>
                                                <span>Содержание и выбытие</span>
                                            </b-link>
                                            <span v-else class="h5 mb-4">Содержание и выбытие</span>

                                            <span v-if="object.lastKeepingData && object.isKept" class="d-flex flex-column">
                                                <span>
                                                    <span>Находится в {{ object.lastKeepingData['executor_contract_object']['contractor_object']['name'] }}</span>
                                                    <span v-if="object.lastKeepingData['attributes']['for_life']"> пожизненно</span>
                                                </span>
                                                <span>c {{ object.lastKeepingData['execution_date_short'] }}</span>
                                            </span>

                                            <span v-if="object.lastDisposalData && !object.isKept" class="d-flex flex-column">
                                                <span>Выбыл из {{ object.lastDisposalData['executor_contract_object']['contractor_object']['name'] }}</span>
                                                <span>{{ object.lastDisposalData['execution_date_short'] }}</span>
                                                <span>{{ object.lastDisposalData['kind_name'] }}</span>
                                            </span>

                                    </div>

                                </b-col>
                            </b-form-row>

                            <b-form-row v-if="object.id && !object.currentPack">
                            </b-form-row>

                        </div>

                    </div>
                </b-tab>
                <b-tab title="Отлов" v-if="ability.can('read', 'CatchingEvent')" :disabled="!object.id" lazy>
                    <common-event-list :prefix="'catching'"
                                       :animal="object"
                                       :event-kinds="catchingEventKinds"
                                       :event-group="'CatchingEvent'"
                                       :show-kind-column="false"/>
                </b-tab>
                <b-tab title="Вет. карта" v-if="ability.can('read', 'ClinicalEvent')"  :disabled="!object.id" lazy>
                    <clinical-event-list :animal="object" @on-event-deleted="onEventDeleted" :key="objectKey"/>
                </b-tab>
                <b-tab title="Содержание" v-if="ability.can('read', 'KeepingEvent')" :disabled="!object.id" lazy>
                    <keeping-event-list :animal="object" @on-event-deleted="onEventDeleted" :key="objectKey"/>
                </b-tab>
                <b-tab title="Выбытие" v-if="ability.can('read', 'DisposalEvent')" :disabled="!object.id" lazy>
                    <disposal-event-list :animal="object" />
                </b-tab>
            </b-tabs>

        </b-card>

        <stub v-else :failed-loading="failedLoading" />

        <confirm-leave-modal ref="leaveDialog" :silent-leave="silentLeave" :leave-browser-confirm="hasChanges"/>

    </div>

</template>

<script>
    import FormField from "../../../components/Forms/FormField";
    import ConfirmLeaveModal from "../../../components/Forms/ConfirmLeaveModal";
    import ObjectFormButtons from "../../../components/Forms/ObjectFormButtons";
    import { ObjectComponentMixin } from "@/components/Forms/ObjectComponentMixin";
    import api from "../../../api";
    import {Animal} from "./animal";
    import CommonEventList from "../Events/CommonEventList";
    import {EventKind} from "../Events/event";
    import DownloadButton from "../../../components/Files/DownloadButton";
    import AnimalPrimaryAvatar from "./AnimalPrimaryAvatar";
    import { mapGetters } from 'vuex';
    import {EventActions} from "@/store/events/constants";
    import KeepingEventList from "../Events/Keeping/KeepingEventList";
    import SingleSelect from "@/components/Select/SingleSelect";
    import RadioList from "@/components/Select/RadioList";
    import DisposalEventList from "@/pages/AppPages/Events/Disposal/DisposalEventList";
    import {ACTIVITIES} from "@/store/auth/auth";
    import Stub from "@/components/Stub.vue";
    import ClinicalEventList from "@/pages/AppPages/Events/Clinical/ClinicalEventList.vue";
    import httpClient from "@/http";
    import DateTimePicker from "@/components/Forms/DateTimePicker.vue";

    export default {
        name: "AnimalDetail",
        components: {
            DateTimePicker,
            ClinicalEventList,
            Stub,
            DisposalEventList,
            RadioList,
            SingleSelect,
            KeepingEventList,
            AnimalPrimaryAvatar,
            CommonEventList, FormField,
            DownloadButton, ConfirmLeaveModal, ObjectFormButtons },
        mixins: [ ObjectComponentMixin ],
        computed: {
            ...mapGetters(['ability', 'tab', 'isSuperuser', 'isInContractor', 'userOrganizationActivities', 'hasMunicipalityRestrictions',
                'userLastValidContract', 'isInCustomer', 'isInController', 'isMunicipalController', 'userOrganizationId', 'isShelter']),
            tabIndex: {
                get: function () {
                    return this.tab
                },
                set(value) {
                    if (!this.loading) {
                        this.$store.dispatch(EventActions.EVENT_TAB_CHANGE, { tab: value });
                    }
                }
            },
            regNumber() {
                return this.object.id ? this.object.regNumber : '-'
            },
            title() {
                return this.object.id ?
                    `${this.object.speciesName}, ${this.object.breedName.toString().toLowerCase()}` : this.objectClass.label
            },
            downloadUrl() {
                return api.animals.pdf.list(api.animals.default.detail(this.object.id));
            },
            getBreedsUrl() {
                return api.breeds.default.list();
            },
            catchingEventKinds() {
                return [EventKind.CATCHING]
            },
            clinicalEventKinds() {
                return [EventKind.INITIAL, EventKind.SURVEY,
                    EventKind.CLINICAL, EventKind.STERILIZATION,
                    EventKind.VACCINATION,EventKind.MARKING
                ]
            },
            keepingEventKinds() {
                return [EventKind.KEEPING]
            },
            disposalEventKinds() {
                return [EventKind.RETURN_TO_OWNER, EventKind.RETURN_TO_HABITAT,
                    EventKind.EUTHANASIA, EventKind.DEATH]
            },
            canCreateKeepingEvents() {
                // PETS-280: записи о содержании могут заводить только приюты
                const canWork = Boolean(this.userLastValidContract);
                const isAnimalKept = this.object.isKept;
                return this.isShelter && canWork && !isAnimalKept || this.isSuperuser;
            },
            canCreateInitialInspectionEvents() {
                const hasLastDistinctiveData = this.object.hasLastDistinctiveData
                const isVet = this.isInContractor && this.userOrganizationActivities.includes(ACTIVITIES.VET);
                const canWork = Boolean(this.userLastValidContract);
                let canCreateVetEvents = !hasLastDistinctiveData && isVet && canWork;
                if (canCreateVetEvents && this.isShelter) {
                    const isAnimalKept = this.object.isKept;
                    const isKeptInUserShelter = this.object.keepingPlaceId ? this.object.keepingPlaceId === this.userOrganizationId : false;
                    canCreateVetEvents = canCreateVetEvents && isAnimalKept && isKeptInUserShelter;
                }
                return canCreateVetEvents || this.isSuperuser;
            },
            // canDelete() {
            //     return this.ability.can('destroy', this.object) && (!this.object.events || this.object.events && this.object.events.length === 0)
            // },
            canDownloadPdf() {
                let canDownloadPdf = true;
                if (!this.isInController && this.isInContractor && this.hasMunicipalityRestrictions) {  // PETS-293: ограничиваем доступ для приютов
                    return this.object.keepingPlaceId === this.userOrganizationId  // приюты могут выгружать карточки животных только при условии их содержания
                }
                return canDownloadPdf
            }
        },
        methods: {
            getReviewTooltip() {
                return 'Проверено ' + this.object.reviewDate
            },
            getStaleReviewTooltip() {
                return `После проверки ${this.object.reviewDate} были внесены изменения`;
            },
            onAvatarUploaded(data) {
                this.form.image = data['image'];
                this.form.avatarId = data['id'];
            },
            onAvatarUpdated(data) {
                this.objectData = data;
                this.object.applyData(data);
            },
            addInitialInspection() {
                this.$router.push({ name: 'eventCreate', params: { kind: EventKind.INITIAL, animalId: this.object.id } })
            },
            addKeeping() {
                this.$router.push({ name: 'eventCreate', params: { kind: EventKind.KEEPING, animalId: this.object.id } })
            },
            onEventDeleted() {
                const vm = this;
                vm.objectData = null;
                vm.resetForm().then(() => {
                    // this.objectKey = new Date().getTime()
                });

            },
            onDelete() {

            },
            getReviewDateStr() {
                return this.object.reviewDate
            },
            onReviewDateChanged(date, fieldName) {
                const vm = this;
                const url = api.animals.review.list(api.animals.default.detail(vm.objectId))
                vm.onModelDateChanged(date, fieldName);
                let data = vm.prepareData()
                httpClient.patch(url, data)
                    .then((response) => {
                        return new Promise((resolve) => { resolve() })
                    }).catch((reason) => {
                        vm.$bvToast.toast( `Животное не проверено`,
                        {noCloseButton: true, solid: true, autoHideDelay: 5000, variant: 'danger'});
                    })
                    .then(() => {
                        return vm.updateObject()
                    }).then(() => {
                        vm.$bvToast.toast( `Животное проверено`,
                        {noCloseButton: true, solid: true, autoHideDelay: 5000, variant: 'success'});

                })
            }
        },
        beforeMount() {
            this.objectClass = Animal;
            this.objectId = this.animalId ? this.animalId : this.$route.params.id;
            this.apiEntryPoint = api.animals;
            this.backRoute = 'animalsList';
            this.nextRoute = 'animalDetail';
        },
        mounted() {
            this.onMount();
            this.resetForm().then(() => {
                if (!this.object.id) {
                    httpClient.get(api.animals.nextRegNumber.list())
                        .then((response) => {
                            const number = response.data['number']
                            this.object.regNumber = number;
                            this.form.regNumber = number;
                            this.form.shelterRegNumber = number;
                        })
                }
            });
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.previousRoute = from
            })
        },
        beforeRouteLeave(to, from, next) {
            this.$store.dispatch(EventActions.EVENT_TAB_CHANGE_ROUTE, { route: to.name });
            next()
        }
    }
</script>

<style scoped lang="scss">
    @import "node_modules/bootstrap/scss/functions";
    @import "node_modules/bootstrap/scss/variables";
    .tag {
        background-color: lighten($primary, 42%);
        border-radius: 12px;
        padding: 5px 12px;
        margin-right: 7px;
        margin-top: 5px;
        &.danger {
            background-color: lighten($danger, 42%);
        }
    }
</style>